import { useRef, useEffect } from 'react';
import messages from '../intl/index.js';
import dropdownStyles from './Dropdown.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMessageFormatter } from '../../i18n/format.js';
import { MdIndeterminateCheckBox, MdCheckBox, MdCheckBoxOutlineBlank, MdKeyboardArrowDown, MdKeyboardArrowRight, MdDone } from '../../node_modules/react-icons/md/index.js';
import { Button } from '../../button/Button.js';
import { UNSAFE_Icon } from '../../icon/Icon.js';
import classNames from 'clsx';
import { DsxLoadingSpinner } from '../../icon/icons/loading-spinner.js';

function TreeItem(props) {
  const {
    activeValue,
    option,
    id,
    value,
    onSelect,
    onExpandToggle,
    selectVariant
  } = props;
  const {
    formatMessage
  } = useMessageFormatter(messages);
  const active = option.value === activeValue;
  const selected = value?.includes(option.value);
  const className = classNames(dropdownStyles['option'], dropdownStyles['option-wrapper'], dropdownStyles[`indent-${option.indentLevel}`], option.disabled && dropdownStyles['disabled'], active && dropdownStyles['active'], selected && dropdownStyles['selected']);
  const checkIcon = selectVariant === 'multi' ? option.indeterminate ? MdIndeterminateCheckBox : selected ? MdCheckBox : MdCheckBoxOutlineBlank : undefined;
  const showExpandButton = option.more || (option.children?.length || 0) > 0;
  const expandClassName = classNames(dropdownStyles['expand'], !showExpandButton && dropdownStyles['hidden']);
  const expandIcon = option.loadingState === 'loading' ? DsxLoadingSpinner : option.expanded ? MdKeyboardArrowDown : MdKeyboardArrowRight;
  const ref = useRef(null);
  useEffect(() => {
    if (active) {
      ref.current?.scrollIntoView({
        block: 'nearest'
      });
    }
  }, [active]);
  function handleExpandToggle(event) {
    event.preventDefault();
    event.stopPropagation();
    onExpandToggle(option.value);
  }
  function handleClick() {
    if (!option.disabled) {
      if (selectVariant === 'leaf' && !option.isLeaf) {
        onExpandToggle(option.value);
      } else {
        onSelect(option.value);
      }
    }
  }
  return /*#__PURE__*/jsxs("div", {
    "aria-selected": selected,
    className: className,
    id: id,
    ref: ref,
    role: "option",
    onClick: handleClick,
    children: [/*#__PURE__*/jsx(Button, {
      className: expandClassName,
      icon: expandIcon,
      iconOnly: true,
      size: "small",
      variant: "ui-control",
      onClick: handleExpandToggle,
      tag: option.value,
      children: formatMessage('Expand')
    }), /*#__PURE__*/jsxs("div", {
      className: selectVariant === 'multi' ? dropdownStyles['multi-option-contents'] : dropdownStyles['single-option-contents'],
      children: [checkIcon && /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: checkIcon,
        size: "size-400"
      }), option.label, selectVariant !== 'multi' && selected ? /*#__PURE__*/jsx(UNSAFE_Icon, {
        icon: MdDone,
        size: "size-400"
      }) : /*#__PURE__*/jsx("div", {
        className: dropdownStyles['icon-stub']
      })]
    })]
  }, option.value);
}

export { TreeItem };
